var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAutoFocus = function SvgAutoFocus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C2C2C2",
    d: "M15.6309 20.0947H13.127L12.4014 18.1436H8.67285L7.94531 20.0947H5.5L9.53223 9.90527H11.6279L15.6309 20.0947ZM24.5 9.90527V12.0889H19.959V14.126H23.9033V16.1934H19.959V20.0947H17.4844V9.90527H24.5ZM10.3477 13.5586C10.2797 13.7818 10.2016 14.0103 10.1143 14.2432C10.027 14.4662 9.94476 14.699 9.86719 14.9414L9.36816 16.2803H11.709L11.2061 14.9268C11.1284 14.723 11.0512 14.5043 10.9736 14.2715C10.896 14.0387 10.8178 13.8011 10.7402 13.5586C10.6742 13.3441 10.607 13.137 10.541 12.9365C10.4797 13.1437 10.4167 13.3515 10.3477 13.5586Z"
  })));
};
export default SvgAutoFocus;